// extracted by mini-css-extract-plugin
export default {"message":"_2TDNrY1wzpU2RNliqqW-uZ"};